/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionsTypes from './AddressQAS-ActionTypes';

export const loadAddressQas = (data) => ({
    type: actionsTypes.LOAD_ADDRESS_QAS,
    data,
});

export const clearAddressQas = () => ({
    type: actionsTypes.CLEAR_ADDRESS_QAS,
});

export const loadFormatQas = (data) => ({
    type: actionsTypes.LOAD_FORMAT_QAS,
    data,
});

export const clearFormatQas = () => ({
    type: actionsTypes.CLEAR_FORMAT_QAS,
});

export const getFormatQas = (data) => ({
    type: actionsTypes.GET_FORMAT_QAS,
    data,
});

export const resetQasState = () => ({
    type: actionsTypes.RESET_QAS_STATE,
});

export const flagOnShowValidatedQAS = () => ({
    type: actionsTypes.FLAG_ON_SHOW_VALIDATED_QAS,
});

export const flagOffShowValidatedQAS = () => ({
    type: actionsTypes.FLAG_OFF_SHOW_VALIDATED_QAS,
});

export const flagMFEQasFailed = (data) => ({
    type: actionsTypes.FLAG_MFE_QAS_FAILED,
    data,
});

export const setUnverifiedFlowActive = (data) => ({
    type: actionsTypes.UNVERIFIED_FLOW_ACTIVE,
    data,
});
